import React from 'react';
import { CardDetails } from 'components';

function CardDetailsComponent(props) {
    return <CardDetails {...props} />;
}

export default CardDetailsComponent;
